import type {CommitFunction, TransitionFunction} from '@logistics-frontend/blocks'
import type {ServerError} from '@logistics-frontend/core/utils/network'
import type {Offer} from '@yandex-delivery/api/model/offer'
import type {GetOffersPayload} from '@yandex-delivery/api/service/offer'

import {fetchOffers} from 'src/shared/api'

import {appConfig} from '../../shared/config'

export type FetchOffersCalculateReturnType = {
  response: Array<Offer>
  pollFunction: VoidFunction
}

type FetchOffersCalculateParams = {
  startTransition: TransitionFunction<FetchOffersCalculateReturnType, ServerError>
  body: GetOffersPayload
  onCommit?: CommitFunction<FetchOffersCalculateReturnType>
  onError?: VoidFunction
  selectedVertical?: string
}

export function fetchOffersCalculate(params: FetchOffersCalculateParams): Promise<FetchOffersCalculateReturnType> {
  const {startTransition, body, selectedVertical, onError, onCommit} = params

  return _fetchOffersCalculate()

  async function _fetchOffersCalculate(): Promise<FetchOffersCalculateReturnType> {
    const response = await fetchOffers(body, selectedVertical, appConfig.countryCode)

    return {
      response,
      pollFunction: function pollingHandler() {
        startTransition(_fetchOffersCalculate, {
          onCommit: res => {
            onCommit?.(res)
          },
          onError,
        })
      },
    }
  }
}
